import {Component, OnDestroy} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {PasswordValidator} from "../../../core/validators/password.validator";
import {MustMatch} from "../../../core/validators/must.match";
import {Subject} from "rxjs";
import {RenewCredentialsRequest} from "../../../core/auth/api/renew.credentials.request";
import {PasswordRestService} from "../../../core/auth/services/password.rest.service";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.scss'],
    standalone: false
})
export class PasswordChangeComponent implements OnDestroy {
  public ngUnsubscribe$ = new Subject<void>(); // emit unsubscription
  public password = new FormControl('', [PasswordValidator.validate(), Validators.required, Validators.minLength(8)]);
  public old_password = new FormControl('', [Validators.required]);
  public password_repeat = new FormControl('');
  hide = true;


  public newPasswordForm = this.formBuilder.group({
      old_password: this.old_password,
      password: this.password,
      password_repeat: this.password_repeat
    },
    {
      validators: [MustMatch('password', 'confirm_password')]
    })

  constructor(private formBuilder: FormBuilder,
              private credentialsService: PasswordRestService,
              protected dialogRef: MatDialogRef<PasswordChangeComponent>) {
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  closeDialog(){
    this.dialogRef.close();
  }

  onPasswordChange() {
    if(!this.newPasswordForm.valid) {
      return;
    }

    const request = new RenewCredentialsRequest(this.newPasswordForm.value);

    this.credentialsService.setNewCredentials(request).subscribe(
      (data: any) => {
        this.dialogRef.close({data: 'success'})
      },
      (err: any) => {
        this.dialogRef.close({data: 'error'})
      });
  }
}
